<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1>Copyright Information ©</h1>
<p><strong>Rania Namer Eitah 2022</strong></p><br/>
<p>The right of Rania Namer Eitah. to be identified as author of this work has been asserted by her in accordance with Federal Law No. (7) of UAE, Year 2002, Concerning Copyrights and Neighboring Rights.</p><br/>
<p>All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p><br/>
<p>Any person who commits any unauthorized act in relation to this publication may be liable to legal prosecution and civil claims for damages.</p><br/>
<p>This is a work of fiction. Names, characters, businesses, places, events, locales, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.</p><br/>
<p>ISBN 9789948043423 (Paperback)</p>
<p>ISBN 9789948043430 (E-Book)</p><br/>
<p>Application Number: MC-10-01-7447971</p>
<p>Age Classification: E</p><br/>
<p>The age group that matches the content of the books has been classified according to the age classification system issued by the National Media Council.</p><br/>
<p>Printer Name: iPrint Global Ltd</p>
<p>Printer Address: Witchford, England</p><br/>
<p>First Published 2022</p>
<p>AUSTIN MACAULEY PUBLISHERS FZE</p>
<p>Sharjah Publishing City</p>
<p>P.O Box [519201]</p>
<p>Sharjah, UAE</p>
<p>www.austinmacauley.ae</p>
<p>+971 655 95 202</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?6a512cd8